module.exports = __webpack_public_path__ + "img/frame (113).1a522bf9.jpg";